import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const articles = [
    {
        id: 'article1',
        title: 'Building WAAS: The Journey Begins',
        date: 'May 14, 2025',
        description: 'An inside look at how we launched our first projects and defined our mission.',
        content: (
            <>
                <h2>🚀 Building WAAS: The Journey Begins</h2>
                <p>
                    Welcome to WAAS — Websites As A Service. We’re a team of four lifelong friends, all born in 1999, based in Arizona, with a shared background in computer science and an even deeper love for PC gaming, soccer, and basketball.
                </p>
                <p>
                    WAAS started with one simple idea: help small businesses get high-quality websites without the traditional friction. That meant skipping the confusing jargon, skipping the sky-high retainers, and getting straight to the good stuff — sleek, modern sites with powerful features.
                </p>
                <p>
                    We knew the MVP (Minimum Viable Product) needed to prove three things:
                </p>
                <ul>
                    <li>💡 We could design clean, fun, and animated websites</li>
                    <li>🛠️ We could streamline the process for small business owners</li>
                    <li>📈 We could deliver real value, fast</li>
                </ul>
                <p>
                    In just a few weeks, we launched sites for local businesses — from a nail salon to a bakery — each with custom features like booking flows, admin panels, and mobile-first design. Everything we shipped was animated, Auth-secured, and tailored to each client’s needs.
                </p>
                <p>
                    We’re not a giant agency — just a tight crew that likes to build cool stuff. But that’s also our superpower. WAAS is personal, fast, and genuinely fun to work with. And this MVP? It’s just the beginning.
                </p>
                <p>Thanks for being here for Day One. Let’s see where this goes. 🚧</p>
            </>
        )
    },
    {
        id: 'how-to-get-website-for-nail-salon',
        title: 'How to Get a Custom Website for Your Nail Salon Business',
        date: 'May 16, 2025',
        description: 'How a professional website boosts bookings and trust for nail salons.',
        content: (
            <>
                <div style={{ padding: '0px', backgroundColor: 'black', display: 'flex', justifyContent: 'center' }}>
                    <img
                        src="https://bunnyklawz.com/images/Tier2Sample.png"
                        alt="Custom website for Bunny Klawz Nail Lounge"
                        style={{ width: '35%', height: '240px', objectFit: 'cover', border: 'none' }}
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '90%' }}>
                        <h2>How to Get a Custom Website for Your Nail Salon Business</h2>
                        <p>Your nail salon deserves more than a booking link. A custom website can enhance your brand image, boost your SEO visibility, and create a seamless customer experience that encourages return visits and referrals.</p>
                        <h3>Why Custom Websites Matter for Nail Salons</h3>
                        <ul>
                            <li>📸 Showcase your work with beautiful photo galleries</li>
                            <li>📅 Let clients book appointments directly online</li>
                            <li>🌟 Display glowing customer reviews front and center</li>
                            <li>📍 Clearly show your location, service menu, and hours</li>
                            <li>📈 Rank higher in local search results with SEO-friendly content</li>
                        </ul>
                        <h3>Start with Clear Goals</h3>
                        <p>Do you want more walk-ins? Better branding? Easier booking? Defining your needs up front helps your web designer deliver exactly what your business requires.</p>
                        <h3>Choose a Web Design Partner Who Understands Beauty & Service</h3>
                        <p>Look for someone who has worked with small businesses or salons before. They'll know what features matter most and can make smart suggestions to boost your impact.</p>
                        <h3>Prepare Your Content</h3>
                        <p>Great websites are built on strong content. Include:</p>
                        <ul>
                            <li>Descriptions of your services</li>
                            <li>Pricing or package information</li>
                            <li>Before and after photos</li>
                            <li>Customer testimonials</li>
                            <li>Links to your social media or online booking platforms</li>
                        </ul>
                        <p>Our client <strong>Bunny Klawz</strong> transformed their online presence with a custom site that reflects their unique brand and automates client bookings. <a href="https://bunnyklawz.com" target="_blank" rel="noopener noreferrer">Check it out here</a>.</p>
                        <h3>What to Expect for Cost</h3>
                        <p>A professional nail salon website can range from <strong>$700 to $2,000+</strong>, depending on the number of features and design complexity. Be sure your quote includes mobile responsiveness and SEO setup.</p>
                        <p>👉 <a href="https://weareasite.com/contact" target="_blank" rel="noopener noreferrer"><strong>Contact We Are A Site LLC</strong></a> today to schedule a free consultation and discover how we can help your salon stand out online.</p>
                    </div>
                </div>
            </>
        )
    },
    // {
    //     id: 'why-tattoo-artists-need-a-website',
    //     title: 'Why Tattoo Artists Need Their Own Website—Not Just Instagram',
    //     date: 'May 16, 2025',
    //     description: 'Instagram is not enough. Learn how a site can grow your tattoo business.',
    //     content: (
    //         <>
    //             <div style={{ padding: '0px', backgroundColor: 'black', display: 'flex', justifyContent: 'center' }}>
    //                 <img
    //                     src="https://cat-house.web.app/galleryImages/image3.jpg"
    //                     alt="Custom portfolio website for Cat House Tattoo"
    //                     style={{ width: '75%', height: '240px', objectFit: 'cover', border: 'none' }}
    //                 />
    //             </div>
    //             <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
    //                 <div style={{ display: 'flex', flexDirection: 'column', width: '90%' }}>
    //                     <h2>Why Tattoo Artists Need Their Own Website—Not Just Instagram</h2>
    //                     <p>Instagram is a great discovery tool, but it doesn’t offer full control over your image or client experience. A custom website empowers you to showcase your portfolio, streamline inquiries, and build long-term visibility in your local community.</p>
    //                     <h3>Key Benefits of Having Your Own Website</h3>
    //                     <ul>
    //                         <li>🖼️ Display high-resolution galleries without compression</li>
    //                         <li>📆 Offer a contact form or appointment request page</li>
    //                         <li>🧭 Highlight your style, specialties, and artist bios</li>
    //                         <li>🔎 Rank on Google for searches like "tattoo artist in [city]"</li>
    //                         <li>🔒 Build trust with testimonials, shop policies, and certifications</li>
    //                     </ul>
    //                     <h3>Tell Your Story, Your Way</h3>
    //                     <p>Unlike a social feed, your website lets you present your story, ethos, and creative style without distractions from algorithms or competitors.</p>
    //                     <p>One example: <strong>Cat House Tattoo</strong> in Arizona wanted a site that matched their bold personality and made it easy for customers to explore their flash art. <a href="https://cat-house.web.app" target="_blank" rel="noopener noreferrer">See their full site here</a>.</p>
    //                     <h3>Costs and Setup</h3>
    //                     <p>Expect to invest between <strong>$900 to $2,500</strong> for a fully custom site, depending on complexity. This often includes SEO setup, content creation, and mobile optimization.</p>
    //                     <p>👉 <a href="https://weareasite.com/contact" target="_blank" rel="noopener noreferrer"><strong>Partner with We Are A Site LLC</strong></a> and make your portfolio permanent, searchable, and truly yours.</p>
    //                 </div>
    //             </div>
    //         </>
    //     )
    // },
    {
        id: 'how-to-buy-custom-landscaping-website',
        title: 'How to Buy a Custom Website for a Small Business in Landscaping',
        date: 'May 18, 2025',
        description: 'A step-by-step guide for landscaping business owners looking to build a custom website that drives local leads and showcases their work.',
        content: (
            <>
                <div
                    style={{
                        padding: '0px',
                        backgroundColor: 'black',
                        display: 'flex',
                        justifyContent: 'center'
                    }}
                >
                    <img
                        src="https://doublet-sod.web.app/galleryImages/image11.jpg"
                        alt="Custom website for Double T Sod, a small landscaping business in Texas"
                        style={{
                            width: '75%',
                            height: '240px',
                            objectFit: 'cover',
                            border: 'none'
                        }}
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '90%' }}>
                        <h2>How to Buy a Custom Website for a Small Business in Landscaping</h2>
                        <p>If you're running a landscaping business, your work is all about curb appeal—and your website should be no different. A well-designed, custom website can turn local homeowners and businesses into loyal clients. But if you've never built a website before, knowing <strong>how to buy a custom website for a small business in landscaping</strong> can feel overwhelming. Don’t worry—this guide will walk you through each step.</p>

                        <h3>Why Landscaping Businesses Need a Custom Website</h3>
                        <p>A generic website might get you online, but a <strong>custom website</strong> tailored to your landscaping services will:</p>
                        <ul>
                            <li><strong>Showcase your work</strong> with high-quality photo galleries</li>
                            <li><strong>Make it easy to request quotes or book consultations</strong></li>
                            <li><strong>Improve visibility</strong> on Google with landscaping-specific SEO</li>
                            <li><strong>Stand out from local competitors</strong> who use cookie-cutter templates</li>
                        </ul>

                        <h3>Step-by-Step: How to Buy a Custom Website for Your Landscaping Business</h3>
                        <h4>1. Set Your Website Goals</h4>
                        <p>Before you hire anyone, ask:</p>
                        <ul>
                            <li>Do I want to attract more local clients?</li>
                            <li>Do I need a booking form or quote request form?</li>
                            <li>Should clients be able to call or message me directly?</li>
                            <li>Do I want to rank on Google for searches like “landscaper near me”?</li>
                        </ul>

                        <h4>2. Choose a Web Design Company That Understands Small Businesses</h4>
                        <p>Look for a company or freelancer with experience in:</p>
                        <ul>
                            <li>Small business websites</li>
                            <li>Service-based industries</li>
                            <li>Mobile-optimized and SEO-ready designs</li>
                        </ul>
                        <p><em>Tip: Ask to see examples of landscaping or contractor websites they’ve built before.</em></p>

                        <h4>3. Pick a Custom Design, Not a Template</h4>
                        <p>Templates are fast and cheap, but a <strong>custom website</strong>:</p>
                        <ul>
                            <li>Reflects your branding (colors, logo, tone)</li>
                            <li>Highlights your unique services (e.g., hardscaping, irrigation, lawn care)</li>
                            <li>Allows features like service area maps, testimonial sliders, and quote request forms</li>
                        </ul>

                        <h4>4. Prepare Your Content</h4>
                        <p>You’ll need:</p>
                        <ul>
                            <li>A short description of your business</li>
                            <li>List of services</li>
                            <li>High-quality photos (before/after work is ideal)</li>
                            <li>Reviews from past clients</li>
                            <li>Contact information and hours</li>
                        </ul>
                        <p>A good developer or agency can help with writing content if you’re not sure what to say.</p>

                        <h4>5. Ask About Hosting and Maintenance</h4>
                        <p>Make sure you understand:</p>
                        <ul>
                            <li>Where your site will be hosted</li>
                            <li>How updates, backups, and security are handled</li>
                            <li>Whether ongoing support is available</li>
                        </ul>

                        <h4>6. Invest in Local SEO</h4>
                        <p>To get found on Google, your site should be optimized with:</p>
                        <ul>
                            <li>Landscaping-related keywords</li>
                            <li>City or service-area targeting (e.g., "Scottsdale lawn care")</li>
                            <li>Google Business Profile integration</li>
                            <li>Fast page speed and mobile responsiveness</li>
                        </ul>

                        <h3>How Much Does a Custom Landscaping Website Cost?</h3>
                        <p>Most small landscaping business websites cost between <strong>$800 to $2,500</strong>, depending on:</p>
                        <ul>
                            <li>Number of pages</li>
                            <li>Custom features (photo galleries, forms, blogs)</li>
                            <li>SEO and content creation</li>
                            <li>Ongoing maintenance</li>
                        </ul>
                        <p>Ask for a clear quote before starting, and make sure it includes everything you need.</p>

                        <h3>Get a Custom Landscaping Website from We Are A Site LLC</h3>
                        <p>At <strong>We Are A Site LLC</strong>, we specialize in building custom websites for small businesses like yours—designed to convert visitors into clients. Whether you’re just starting your landscaping company or need a redesign, we’ll create a site that reflects your brand, builds trust, and drives results.</p>
                        <ul>
                            <li>✅ Custom design tailored to landscapers</li>
                            <li>✅ Mobile-friendly and SEO-optimized</li>
                            <li>✅ Booking forms, quote requests, and more</li>
                            <li>✅ Transparent pricing and friendly support</li>
                        </ul>
                        <p>One of our recent projects is for <strong>Double T Sod</strong>, a Texas-based landscaping and turf provider. <a href="https://doublet-sod.web.app" target="_blank" rel="noopener noreferrer">View their custom website here</a>.</p>
                        <p>👉 <a href="https://weareasite.com/contact" target="_blank" rel="noopener noreferrer"><strong>Contact us today</strong></a> to get a free quote and see how we can bring your landscaping business online the right way.</p>
                    </div>
                </div>
            </>
        )
    }
];


const NewsWindow = ({ isNewsOpen, setIsNewsOpen, zFILO, addToZFILO, removeFromZFILO }) => {
    const [selectedArticle, setSelectedArticle] = useState(null);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const path = location.pathname;
        const matched = path.match(/^\/news\/([\w-]+)$/); // Allows letters, numbers, underscores, and hyphens
        if (matched) {
            setSelectedArticle(matched[1]);
        } else if (path === '/news') {
            setSelectedArticle(null);
        }
    }, [location.pathname]);

    const zIndex = zFILO.indexOf('news') !== -1 ? 1000 + zFILO.indexOf('news') : 1000;

    const handleClose = () => {
        setIsNewsOpen(false);
        removeFromZFILO('news');
        navigate('/');
    };

    const handleMinimize = () => {
        setIsNewsOpen(false);
        removeFromZFILO('news');
        navigate('/');
    };

    if (!isNewsOpen) return null;

    let helmet;

    if (!selectedArticle) {
        // Default /news page
        helmet = (
            <Helmet>
                <title>WAAS Blog & News | We Are A Site</title>
                <meta
                    name="description"
                    content="Stay updated with news, tips, and insights from the We Are A Site team. Learn how to grow your online presence."
                />
            </Helmet>
        );
    } else {
        const article = articles.find((a) => a.id === selectedArticle);
        if (article) {
            helmet = (
                <Helmet>
                    <title>{article.title} | We Are A Site</title>
                    <meta name="description" content={article.description} />
                </Helmet>
            );
        }
    }

    return (
        <>
            {helmet}
            <div className='NewsWindow DesktopWindow' style={{ zIndex }}>
                <div className='NewsWindowTitleBar DesktopWindowTitleBar'>
                    <span className='Title'>WAAS Newsletter</span>
                    <div className='ResizeButtons'>
                        <img src='/images/MinimizeIcon.png' alt='Minimize' onClick={handleMinimize} />
                        <img src='/images/MaximizeIcon.png' alt='Maximize' />
                        <img src='/images/SystemMessageCloseButton.png' alt='Close' onClick={handleClose} />
                    </div>
                </div>
                <div className='NewsWindowNavigationBar'>
                    <div className='NewsWindowNavigationBarLeft'>
                        <img
                            src='/images/PortfolioBackIcon.png'
                            alt='Back'
                            onClick={() => {
                                setSelectedArticle(null);
                                navigate('/news');
                            }}
                        />
                        <img src='/images/PortfolioForwardIcon.png' alt='Forward' />
                        <div className='SearchContainer'>
                            <input value={`https://WAAS.News.Newsletter.com`} readOnly />
                            <img src='/images/SearchIcon.png' alt='Search' />
                        </div>
                    </div>
                    <div className='NewsWindowNavigationBarRight'>
                        <img src='/images/BookmarkIcon.png' alt='Bookmark' />
                        <img
                            src='/images/HomeIcon.png'
                            alt='Home'
                            onClick={() => {
                                setSelectedArticle(null);
                                navigate('/news');
                            }}
                        />
                    </div>
                </div>

                {!selectedArticle && (
                    <div className='NewsResults'>
                        {/* <span className='SearchResultIndex'>{articles.length} articles found for "WAAS Newsletter"</span> */}
                        <div className='NewsArticleContainer'>
                            {[...articles]
                                .sort((a, b) => new Date(b.date) - new Date(a.date))
                                .map((article) => (
                                    <div
                                        key={article.id}
                                        className='NewsSearchItem'
                                        onClick={() => {
                                            setSelectedArticle(article.id);
                                            navigate(`/news/${article.id}`);
                                        }}
                                    >
                                        <div>
                                            <h3>{article.title}</h3>
                                            <p>{article.description}</p>
                                        </div>
                                        <div>
                                            <span>{article.date}</span>
                                            <hr />
                                        </div>
                                    </div>

                                ))}
                        </div>
                    </div>
                )}

                {selectedArticle && (
                    <div className='NewsArticleContent'>
                        {articles.find((article) => article.id === selectedArticle)?.content}
                    </div>
                )}
            </div>
        </>
    );
};

export default NewsWindow;
